const DEFAULT_GPT_FLOW_CONFIG = {
  personal_profile_chat: "Personal Profile Chat",
  personal_profile_summary: "Personal Profile Summary",
  organization_member_profile_chat: "Organization Member Profile Chat",
  organization_member_profile_summary: "Organization Member Summary",
  candidate_profile_chat: "Candidate Profile Chat",
  candidate_profile_summary: "Candidate Profile Summary",
  team_profile_chat: "Team Profile Chat",
  team_profile_summary: "Team Profile Summary",
  team_member_profile_chat: "Team Member Profile Chat",
  team_member_profile_summary: "Team Member Summary",
  assessment: "Candidate Assessment Flow",
  assessment_pregen: "candidate evaluation pregen",
  assessment_summary: "Assessment Summary",
};

// Overrides for RRA. Add more as needed.
const RRA_GPT_FLOW_CONFIG = {
  candidate_profile_chat: "RRAQA candidate profile chat",
  candidate_profile_summary: "RRAQA candidate summary v1",
  assessment: "RRAQA assessment flow",
  assessment_summary: "RRAQA executive summary v1",
};

export type GPTFlowKey = keyof typeof DEFAULT_GPT_FLOW_CONFIG;

type GPTFlowConfig = Record<GPTFlowKey, string>;

const getGptFlowsConfig = () => {
  const isRraGptFlow = import.meta.env.VITE_GPT_FLOW_CONFIG === "rraqa";

  if (isRraGptFlow) {
    return {
      ...DEFAULT_GPT_FLOW_CONFIG,
      ...RRA_GPT_FLOW_CONFIG,
    };
  }
  return DEFAULT_GPT_FLOW_CONFIG as GPTFlowConfig;
};

export const getGptFlowKey = (flowId: GPTFlowKey) => {
  const config = getGptFlowsConfig();
  return config[flowId];
};
